import { calculateDescenderOffset } from '@/components/public/Visualisations/BubblesV2/bubblesVisualisationHelpersV2'
import { HeaderMetadata } from '@/components/public/Visualisations/BubblesV2/Metadata'
import { Shapes } from '@/components/public/Visualisations/types'
import { Coordinate2D } from '@/types'
import Konva from 'konva'

export class HeaderTextV2 extends Konva.Text implements Shapes.Shape {
  private _metadata: HeaderMetadata
  capabilities: Shapes.Capability[] = []

  constructor(metadata: HeaderMetadata) {
    super({
      fontSize: metadata.fontSize,
      fontFamily: metadata.fontFamily,
      listening: false,
    })

    this._metadata = metadata
  }

  get key() {
    return this.path.toString()
  }

  get path() {
    return this._metadata.path
  }

  get center(): Coordinate2D {
    return this.position()
  }

  refresh() {
    this.fill(this._metadata.fontColour)
    this.text(this._metadata.name)
    this.offsetX(this.width() / 2)
    const descenderOffset = calculateDescenderOffset(
      this.text(),
      this._metadata.fontSize,
      this._metadata.fontFamily,
    )
    this.offsetY(this.height() / 2 + descenderOffset)
  }
}
